const defaultHeaders = {
  'Content-Type': 'application/json;charset=UTF-8'
}

export default defaultHeaders